import { FiltersTypes } from 'store/modules/online_search_store/types';
import _ from 'underscore';
import onlineSearchInitialState from 'store/modules/online_search_store/initial_state';
import { ManagementMember } from 'store/modules/management_store/types';
import { BiddingTypes } from './types';
import { ActivitiesTypes } from '../followup_online_search_store/types';

export interface CommentProps {
  bidding_comment: {
    bidding_id: string | number;
    message: string;
    client_id?: number;
  };
}
interface BiddingParamsTypes {
  id: string | null;
  orgao_uasg: string;
  tipo_orgao_id: number[];
  processo: string;
  objeto: string;
  observacao: string;
  // orgao_endereco: string;
  nome_orgao: string;
  itens: string;
  notice_number: string;
  'modified[from]': string | null;
  'modified[to]': string | null;
  'data_validade[from]': string | null;
  'data_validade[to]': string | null;
  orgao_estado_id: number[];
  cities_ids: string[];
  modalities_ids: number[];
  tipo_agrupamento_id: number | null | undefined;
  exact_search: boolean | null;
  vigente_somente: boolean | null;
  tem_edital: boolean | null;
  pregao_tem: boolean | null;
  match_somente: boolean | null;
  pregao_fonte_id: number[];
  ranges: string[];
  atividade: string[];
  page: number;
  per_page: number;
  favorite_scope?: string | null;
  favorite?: boolean | null;
  managed?: boolean | null;
  archived?: boolean | null;
  order?: string | null;
  order_direction?: string | null;
  access_token?: string | null;
}

interface getBiddingParams {
  filters?: FiltersTypes;
  page?: number;
  per_page?: number;
  favorite_scope?: string | null;
  favorite?: boolean | null;
  managed?: boolean | null;
  archived?: boolean | null;
  order?: string | null;
  order_direction?: string | null;
  access_token?: string | null;
  activities_list: Array<ActivitiesTypes>;
}

const biddingParams = (
  filters: FiltersTypes,
  page: number,
  per_page: number,
  favorite_scope: string | null,
  favorite: boolean | null,
  managed: boolean | null,
  archived: boolean | null,
  order: string | null,
  order_direction: string | null,
  access_token: string | null,
  activities_list: Array<ActivitiesTypes>,
) => {
  const ranges = [];
  if (filters.national) ranges.push('0');
  if (filters.international) ranges.push('1');

  const bidding_params: BiddingParamsTypes = {
    id: filters.id ? filters.id : null,
    orgao_uasg: filters.uasg,
    tipo_orgao_id: filters.publicBodyTypes?.map((option) => option.value),
    processo: filters.processNumber,
    objeto: filters.object,
    observacao: filters.note,
    // orgao_endereco: filters.address,
    nome_orgao: filters.publicBody,
    itens: filters.itens,
    notice_number: filters.noticeNumber,
    'modified[from]': filters.includeDateRange.from,
    'modified[to]': filters.includeDateRange.to,
    'data_validade[from]': filters.deadlineDateRange.from,
    'data_validade[to]': filters.deadlineDateRange.to,
    orgao_estado_id: filters.states?.map((option) => option.value),
    cities_ids: filters.cities?.map((option) => option.value),
    modalities_ids: filters.modalities?.map((option) => option.value),
    tipo_agrupamento_id: _.isEmpty(filters.situation) ? null : filters.situation?.value,
    exact_search: filters.exact_search ? true : null,
    vigente_somente: filters.validities ? true : null,
    tem_edital: filters.hasNotice ? true : null,
    pregao_tem: filters.hasMonitored ? true : null,
    match_somente: filters.onlyMatch ? true : null,
    pregao_fonte_id: filters.monitoredPortals?.map((option) => option.value),
    ranges,
    atividade:
      filters.activities.length === 0
        ? activities_list?.map((option) => option.codigo)
        : filters.activities?.map((option) => option.codigo),
    page,
    per_page,
  };

  if (favorite_scope !== null) bidding_params.favorite_scope = favorite_scope;
  if (favorite !== null) bidding_params.favorite = favorite;
  if (managed !== null) bidding_params.managed = managed;
  if (archived !== null) bidding_params.archived = archived;
  if (order !== null) bidding_params.order = order;
  if (order !== null) bidding_params.order = order;
  if (order_direction !== null) bidding_params.order_direction = order_direction;
  if (access_token !== null) bidding_params.access_token = access_token;

  return bidding_params;
};

export const getBiddings = (params: getBiddingParams, companyId?: number) => {
  const {
    filters = onlineSearchInitialState.onlineSearch.filters,
    activities_list,
    page = 1,
    per_page = 20,
    favorite_scope = null,
    favorite = null,
    managed = null,
    archived = null,
    order = null,
    order_direction = null,
    access_token = null,
  } = params;

  const bidding_params = biddingParams(
    filters,
    page,
    per_page,
    favorite_scope,
    favorite,
    managed,
    archived,
    order,
    order_direction,
    access_token,
    activities_list,
  );

  if (bidding_params.cities_ids.length > 500) {
    return {
      types: [
        BiddingTypes.GET_BIDDINGS_REQUEST,
        BiddingTypes.GET_BIDDINGS_SUCCESS,
        BiddingTypes.GET_BIDDINGS_FAILURE,
      ],
      promise: (client: any) =>
        client.post(`/biddings.json${companyId ? `?companyId=${companyId}` : ''}`, bidding_params),
    };
  }

  return {
    types: [
      BiddingTypes.GET_BIDDINGS_REQUEST,
      BiddingTypes.GET_BIDDINGS_SUCCESS,
      BiddingTypes.GET_BIDDINGS_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`/biddings.json${companyId ? `?companyId=${companyId}` : ''}`, {
        params: bidding_params,
      }),
  };
};

export const getBidding = (biddingId: string, companyId: number) => {
  return {
    types: [
      BiddingTypes.GET_BIDDING_REQUEST,
      BiddingTypes.GET_BIDDING_SUCCESS,
      BiddingTypes.GET_BIDDING_FAILURE,
    ],
    biddingId,
    promise: (client: any) => client.get(`/biddings/${biddingId}.json?companyId=${companyId}`),
  };
};

export const createFavorite = (
  biddingId: string,
  contactName: string,
  companyId: number | null = null,
) => {
  const data = {
    bidding_id: biddingId,
    companyId,
  };
  return {
    types: [
      BiddingTypes.CREATE_BIDDING_FAVORITE_REQUEST,
      BiddingTypes.CREATE_BIDDING_FAVORITE_SUCCESS,
      BiddingTypes.CREATE_BIDDING_FAVORITE_FAILURE,
    ],
    biddingId,
    contactName,
    companyId,
    promise: (client: any) => client.post('/minhas_licitacoes/favorites', data),
  };
};

export const destroyFavorite = (
  biddingId: string,
  contactName: string,
  companyId: number | null = null,
) => {
  const params = {
    data: {
      bidding_id: biddingId,
      companyId,
    },
  };

  return {
    types: [
      BiddingTypes.DESTROY_BIDDING_FAVORITE_REQUEST,
      BiddingTypes.DESTROY_BIDDING_FAVORITE_SUCCESS,
      BiddingTypes.DESTROY_BIDDING_FAVORITE_FAILURE,
    ],
    biddingId,
    contactName,
    companyId,
    promise: (client: any) => client.delete(`/minhas_licitacoes/favorites/${biddingId}`, params),
  };
};

export const destroyFavoriteAll = (
  biddings: number[],
  contactName: string,
  companyId: number | null = null,
  all: boolean = false,
  removeFromList: boolean = false,
  scope: string | null = null,
  members: Array<ManagementMember> | null = null,
) => {
  const params = {
    data: {
      biddings,
      companyId,
      all,
      scope,
      ...(members ? { member_ids: members.map((member) => member.id) } : {}),
    },
  };

  return {
    types: [
      BiddingTypes.DESTROY_BIDDING_FAVORITE_ALL_REQUEST,
      BiddingTypes.DESTROY_BIDDING_FAVORITE_ALL_SUCCESS,
      BiddingTypes.DESTROY_BIDDING_FAVORITE_ALL_FAILURE,
    ],
    biddings,
    contactName,
    companyId,
    all,
    removeFromList,
    scope,
    removedNames: members ? members.map((member) => member.nome) : [contactName],
    promise: (client: any) => client.delete(`/minhas_licitacoes/favorites/all`, params),
  };
};

export const createBiddingManaged = (biddingId: number, companyId: number) => {
  const data = {
    bidding_id: biddingId,
    companyId,
  };
  return {
    types: [
      BiddingTypes.CREATE_BIDDING_MANAGED_REQUEST,
      BiddingTypes.CREATE_BIDDING_MANAGED_SUCCESS,
      BiddingTypes.CREATE_BIDDING_MANAGED_FAILURE,
    ],
    biddingId,
    promise: (client: any) => client.post('/gerenciar_licitacoes/gerenciar', data),
  };
};

export const destroyBiddingManaged = (
  biddingId: number,
  companyId?: number,
  contact_client_id?: number,
) => {
  const params = {
    data: {
      bidding_id: biddingId,
      companyId,
      contact_client_id,
    },
  };
  return {
    types: [
      BiddingTypes.DESTROY_BIDDING_MANAGED_REQUEST,
      BiddingTypes.DESTROY_BIDDING_MANAGED_SUCCESS,
      BiddingTypes.DESTROY_BIDDING_MANAGED_FAILURE,
    ],
    biddingId,
    companyId,
    contact_client_id,
    promise: (client: any) => client.delete(`/gerenciar_licitacoes/gerenciar/${biddingId}`, params),
  };
};

export const getComments = (biddingId: string) => {
  return {
    types: [
      BiddingTypes.GET_COMMENTS_REQUEST,
      BiddingTypes.GET_COMMENTS_SUCCESS,
      BiddingTypes.GET_COMMENTS_FAILURE,
    ],
    biddingId,
    promise: (client: any) =>
      client.get(`/minhas_licitacoes/comments.json`, { params: { bidding_id: biddingId } }),
  };
};

export const createComment = (
  biddingId: string | number,
  contactName: string,
  data: CommentProps,
  profileId: number,
) => {
  return {
    types: [
      BiddingTypes.CREATE_COMMENT_REQUEST,
      BiddingTypes.CREATE_COMMENT_SUCCESS,
      BiddingTypes.CREATE_COMMENT_FAILURE,
    ],
    biddingId,
    contactName,
    profileId,
    promise: (client: any) => client.post('/minhas_licitacoes/comments', data),
  };
};

export const destroyComment = (biddingId: string | number, commentId: string | number) => {
  return {
    types: [
      BiddingTypes.DESTROY_COMMENT_REQUEST,
      BiddingTypes.DESTROY_COMMENT_SUCCESS,
      BiddingTypes.DESTROY_COMMENT_FAILURE,
    ],
    biddingId,
    commentId,
    promise: (client: any) => client.delete(`/minhas_licitacoes/comments/${commentId}`),
  };
};

export const getBiddingPrBw = (boletin_id: string | undefined, id: string | undefined) => {
  return {
    types: [
      BiddingTypes.GET_BIDDING_PR_BW_REQUEST,
      BiddingTypes.GET_BIDDING_PR_BW_SUCCESS,
      BiddingTypes.GET_BIDDING_PR_BW_FAILURE,
    ],
    id,
    boletin_id,
    promise: (client: any) =>
      client.get(`/boletim_web/public/boletins/${boletin_id}/biddings/${id}.json`),
  };
};

export const getBiddingExpired = (bidding: number) => {
  return {
    types: [
      BiddingTypes.GET_BIDDING_EXPIRED_REQUEST,
      BiddingTypes.GET_BIDDING_EXPIRED_SUCCESS,
      BiddingTypes.GET_BIDDING_EXPIRED_FAILURE,
    ],
    promise: (client: any) => client.get(`/bidding/${bidding}`),
  };
};

export const biddingsOverview = (companyId: number) => {
  return {
    types: [
      BiddingTypes.BIDDINGS_OVERVIEW_REQUEST,
      BiddingTypes.BIDDINGS_OVERVIEW_SUCCESS,
      BiddingTypes.BIDDINGS_OVERVIEW_FAILURE,
    ],
    promise: (client: any) => client.get(`/biddings_overview`, { params: { companyId } }),
  };
};

export const solicitarEdital = (bidding_id: number | string) => {
  return {
    types: [
      BiddingTypes.SOLICITAR_EDITAL_REQUEST,
      BiddingTypes.SOLICITAR_EDITAL_SUCCESS,
      BiddingTypes.SOLICITAR_EDITAL_FAILURE,
    ],
    promise: (client: any) => client.post('/solicitar_edital', { bidding_id }),
  };
};
